angular.module("acl.common.localize").run(function(AppConfig, Dictionaries) {
  AppConfig.supportedLanguages.forEach(language => {
    angular.extend(Dictionaries, require(`./cmn_msg_${language}.json`));
    angular.extend(Dictionaries, require(`./dv_msg_${language}.json`));
  });
});
